import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../services/authentication.service';
import { LoadingService } from '../../pages/services/loading.service';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
  private authenticationService = inject(AuthenticationService);
  private loadingService = inject(LoadingService);

  intercept(request: HttpRequest<string>, next: HttpHandler): Observable<HttpEvent<string>> {

    const skipUrls = [
      '/api/auth/verify-user',
      '/api/auth/verify-otp',
      '/api/auth/resend-otp',
      '/api/auth/sign-up',
      '/open-api/'
    ];

    if (skipUrls.some(url => request.url.includes(url))) {
      return next.handle(request);
    }

    const token = sessionStorage.getItem('auth_token');
    const isApiUrl = request.url.startsWith(environment.BACK_END_POINT);

    if (isApiUrl && token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    this.loadingService.show();

    return next.handle(request).pipe(
      finalize(() => this.loadingService.hide())
    );
  }}
